import React, { useState } from "react";
import ClientUsers from "./Clientlist";

import PendingDealerList from "./Pending-dealerlist";
import ClientCreation from "./Create-client";
import InternalUserCreation from "./Create-internal";
import InternalUsersList from "./All-internal-userslist";
import ValueSettings from "./valuesettings";

const UsersTabs = () => {
  const [selectedTab, setSelectedTab] = useState("contact");

  const tabs = [
    // { key: "home", label: "Create-Client" },
    // { key: "profile", label: "All-Clients" },
    { key: "contact", label: "Create-Internal-User" },
    { key: "about", label: "All-Internal-Users" },
    { key: "contact1", label: "Dealer-list" },
    { key: "settings", label: "Delivery-wallet" },
  ];

  return (
    <div className="users-tabs-page container-fluid">
      {/* Page-only styles */}
      <style>{`
        .users-tabs-page .nav-tabs {
          border-bottom: 1px solid #dcdcdc;
          background: #ffffff;
        }
        .users-tabs-page .nav-tabs .nav-link {
          border: none;
          color: #005487;
          font-weight: 500;
          padding: 10px 18px;
          margin-right: 6px;
          background: transparent;
          border-radius: 6px 6px 0 0;
          cursor: pointer;
        }
        .users-tabs-page .nav-tabs .nav-link.active {
          color: #005487;
          border-bottom: 3px solid #005487;
          font-weight: 600;
        }
        .users-tabs-page .tab-content {
          border: 1px solid #dcdcdc;
          border-top: none;
          border-radius: 0 0 6px 6px;
          background: #fff;
        }
      `}</style>

      {/* Tabs Header */}
      <ul className="nav nav-tabs mb-3">
        {tabs.map((tab) => (
          <li className="nav-item" key={tab.key}>
            <button
              className={`nav-link ${selectedTab === tab.key ? "active" : ""}`}
              onClick={() => setSelectedTab(tab.key)}
              type="button"
            >
              {tab.label}
            </button>
          </li>
        ))}
      </ul>

      {/* Tabs Content */}
      <div className="tab-content col-12 ">
        {/* Create Client */}
        {/* {selectedTab === "home" && <ClientCreation />} */}

        {/* All Clients */}

        {/* {selectedTab === "profile" && <ClientUsers />} */}

        {/* Create Internal User */}
        {selectedTab === "contact" && <InternalUserCreation />}

        {/* All Internal Users */}
        {selectedTab === "about" && <InternalUsersList />}

        {selectedTab === "contact1" && <PendingDealerList />}
        {selectedTab === "settings" && <ValueSettings />}

        {/* Pending Dealer List */}
      </div>
    </div>
  );
};

export default UsersTabs;
